import { render, staticRenderFns } from "./DownloadDocumentsButton.vue?vue&type=template&id=34d17b2c"
import script from "./DownloadDocumentsButton.vue?vue&type=script&lang=js"
export * from "./DownloadDocumentsButton.vue?vue&type=script&lang=js"
import style0 from "./DownloadDocumentsButton.vue?vue&type=style&index=0&id=34d17b2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports